import { render } from "./Dashboard.vue?vue&type=template&id=7936068b&scoped=true"
import script from "../js/dashboard.js?vue&type=script&lang=js&external"
export * from "../js/dashboard.js?vue&type=script&lang=js&external"

import "./Dashboard.vue?vue&type=style&index=0&id=7936068b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7936068b"]])

export default __exports__